module.exports = __webpack_public_path__ + "assets/pubsubjs.6824c9b2.svg";